import { useCallback, useEffect, useMemo, useState } from 'react';
import { t } from '@/lib/i18n';
import { agentSessionsService, type RosterItem } from '@/services/roros/agent-sessions.service';

export function useAgentSessionRoster() {
  const [roster, setRoster] = useState<RosterItem[]>([]);

  // AC-AGS-M4-3: load roster for actor picker on mount
  useEffect(() => {
    agentSessionsService.getRoster().then(setRoster).catch(() => setRoster([]));
  }, []);

  // Build actor options from roster (AC-AGS-M4-3)
  const actorOptions = useMemo(() => {
    return roster.map((r) => ({ value: r.actorId, label: r.actorName }));
  }, [roster]);

  const getActorName = useCallback((actorId: string | null | undefined) => {
    return roster.find((r) => r.actorId === (actorId ?? ''))?.actorName ?? t('AI Operator');
  }, [roster]);

  return {
    roster,
    actorOptions,
    getActorName,
  };
}
